<template>
  <div class="electric">
    <van-row
      class="electric-search"
      @scroll="handleScroll"
      :class="{ electricFixedTop: electricFixedTop, isiOSX: isiOSX }"
      id="changeSearch"
    >
      <van-search v-model="value" @click="search()" readonly />
      <img
        class="back"
        src="../../assets/selfSupport/backbefore@2x.png"
        @click="goBack()"
      />
      <img class="littleTitle" :src="logo" />
      <img class="search" :src="searchImgT" v-if="current == 0" />
      <img class="search" :src="searchImgT" v-if="current == 1" />
      <img
        class="share"
        src="../../assets/selfSupport/share.png"
        @click="support()"
      />
    </van-row>
    <div class="electric-content">
      <van-swipe class="electric-swipe" @change="onChange" v-if="swiper">
        <van-swipe-item v-for="(item, index) in swiper" :key="index">
          <img
            class="item"
            :src="item.img_url"
            @error="defaultPro()"
            @click="Router(item.href)"
          />
        </van-swipe-item>

        <div class="custom-indicator" slot="indicator">
          <span class="indexes">{{ label + 1 }}/{{ slideLen }}</span>
        </div>
      </van-swipe>

      <van-swipe class="electric-model" v-if="top_cate">
        <van-swipe-item v-bind:class="{ 'class-a': isA }">
          <div class="swipeBox">
            <div class="box">
              <van-row type="flex" justify="space-left">
                <van-col
                  span="4"
                  v-for="(item, index) in top_cate"
                  :key="index"
                  :style="topCateP"
                  v-if="index < 5"
                >
                  <div @click="classify1(item.id)">
                    <img :src="item.icon" @error="iconDefu()" />
                  </div>
                  <div>{{ item.name }}</div>
                </van-col>
              </van-row>
              <van-row type="flex" justify="space-left">
                <van-col
                  span="4"
                  v-for="(item, index) in top_cate"
                  :key="index"
                  :style="topCateP"
                  v-if="index > 4 && index < 10"
                >
                  <div @click="classify1(item.id)" class="bottom">
                    <img :src="item.icon" @error="iconDefu()" />
                  </div>
                  <div>{{ item.name }}</div>
                </van-col>
              </van-row>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item
          v-bind:class="{ 'class-a': isA }"
          v-if="top_cate.length > 10"
        >
          <div class="swipeBox">
            <div class="box">
              <van-row type="flex" justify="space-left">
                <van-col
                  span="4"
                  v-for="(item, index) in top_cate"
                  :key="index"
                  :style="topCateP"
                  v-if="index > 9 && index < 15"
                >
                  <div @click="classify1(item.id)">
                    <img :src="item.icon" @error="iconDefu()" />
                  </div>
                  <div>{{ item.name }}</div>
                </van-col>
              </van-row>
              <van-row type="flex" justify="space-left">
                <van-col
                  span="4"
                  v-for="(item, index) in top_cate"
                  :key="index"
                  :style="topCateP"
                  v-if="index > 14 && index < 20"
                >
                  <div @click="classify1(item.id)" class="bottom">
                    <img :src="item.icon" @error="iconDefu()" />
                  </div>
                  <div>{{ item.name }}</div>
                </van-col>
              </van-row>
            </div>
          </div>
        </van-swipe-item>

        <van-swipe-item
          v-bind:class="{ 'class-a': isA }"
          v-if="top_cate.length > 20"
        >
          <div class="swipeBox">
            <div class="box">
              <van-row type="flex" justify="space-left">
                <van-col
                  span="4"
                  v-for="(item, index) in top_cate"
                  :key="index"
                  :style="topCateP"
                  v-if="index > 19 && index < 25"
                >
                  <div @click="classify1(item.id)">
                    <img :src="item.icon" @error="iconDefu()" />
                  </div>
                  <div>{{ item.name }}</div>
                </van-col>
              </van-row>
              <van-row type="flex" justify="space-left">
                <van-col
                  span="4"
                  v-for="(item, index) in top_cate"
                  :key="index"
                  :style="topCateP"
                  v-if="index > 24 && index < 30"
                >
                  <div @click="classify1(item.id)" class="bottom">
                    <img :src="item.icon" @error="iconDefu()" />
                  </div>
                  <div>{{ item.name }}</div>
                </van-col>
              </van-row>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>

      <!--<van-row class="electric-notice" @click="notice()" v-if="shopNotic">
				<img src="../../assets/selfSupport/gonggao.png"/>
				<span class="hot">HOT</span>
				<van-notice-bar :text="shopNotic"/>
			</van-row>-->

      <van-row class="electric-adv" v-if="adv[0]">
        <img
          :src="adv[0].img_url"
          @error="advDefault()"
          @click="dftAdv(adv[0].href)"
        />
      </van-row>

      <!-- <van-row class="electric-dayrec" v-if="dayGoods.length > 0">
				<van-col class="title" span="24">每日好货</van-col>
				<van-col class="label" span="12">
					<span @click="moreDayrec()">发现世界好物<img src="../../assets/selfSupport/lujing1.png" /></span>
				</van-col>
				<van-col class="more" offset="4" span="8">
					<span @click="moreDayrec()">查看更多<img src="../../assets/selfSupport/lujing2.png" /></span>
				</van-col>
			</van-row>
	    <div class="electric-dayrec-list" v-if="dayGoods.length > 0">
				<van-row>
				  <van-col span="8" v-for="(item, index) in dayGoods" :key="index" v-if="index < 3">
				  	<img :src="item.images" @error="defaultPro()" :style="dayGoodsH"  @click="adv1(item.route_url)"/>
				  </van-col>
				</van-row>
			</div> -->

      <!-- <van-row class="electric-spike" v-if="miaoshaShow && miaosha_data.list">
				<van-col class="title" span="24">秒杀单品</van-col>
				<van-col class="label" span="12">
					<span class="time">{{miaoshaBegin}}点场</span>
					<van-count-down :time="time1">
					  <template v-slot="timeData">
					    <span class="downcount">{{checkTime(timeData.hours)}}</span> : <span class="downcount">{{checkTime(timeData.minutes)}}</span> : <span class="downcount">{{checkTime(timeData.seconds)}}</span>
					  </template>
					</van-count-down>
					
				</van-col>
				<van-col class="more" offset="4" span="8">
					<div @click="moreSpike()">
						查看更多<img src="../../assets/selfSupport/lujing3.png" />
					</div>
				</van-col>
				<div class="wrapper">
					<div class="datePrice">
						<ul class="clearfix">
							<li :style="recommendstyle" v-for="(item, index) in miaosha_data.list" :key="index" v-if="index < 3">
								<div class="imgCon" :style="recommendstyle_img">
									<img class="imgPro" :src="item.thumb" @error="defaultPro()" @click="goDetail1(item.id)"/>
								</div>
								<p class="name" @click="goDetail1(item.id)">
									{{item.name}}</p>
								<p class="price">￥{{item.show_min_price}}<del v-if="item.strikeout_price && item.strikeout_price!=0">￥{{item.strikeout_price}}</del><del v-else>￥{{item.activity_min_price}}</del></p>
							</li>
							
						</ul>
					</div>
				</div>
			</van-row> -->

      <!-- 拼团活动 -->
      <img
        v-if="ptAd"
        :src="ptAd.img_url"
        alt=""
        class="groupbuy"
        @click="ptAdv(ptAd.href)"
      />

      <div class="electric-active" v-if="reductionShow && reduction_data.goods">
        <div class="wrap">
          <van-row class="tit">
            <div @click="reduction()">
              <van-col span="12" class="leftT"
                ><span>满额立减</span
                ><img src="../../assets/selfSupport/shangpinfenzu@2x.png"
              /></van-col>
              <van-col span="12" class="rightT">距结束仅剩</van-col>
              <van-col span="12" class="leftB"
                >最高立减{{
                  reduction_data.activity.requirements[0].discount_amount
                }}元</van-col
              >
              <van-col span="12" class="rightB">
                <van-count-down :time="time2">
                  <template v-slot="timeData">
                    <span>{{ checkTime(timeData.days) }}</span
                    >天<span>{{ checkTime(timeData.hours) }}</span
                    >时<span>{{ checkTime(timeData.minutes) }}</span
                    >分<span>{{ checkTime(timeData.seconds) }}</span
                    >秒
                  </template>
                </van-count-down>
              </van-col>
            </div>
          </van-row>
          <van-row class="product">
            <van-col
              span="8"
              v-for="(item, index) in reduction_data.goods"
              :key="index"
              v-if="index < 3"
            >
              <div class="img">
                <img
                  class="imgPro"
                  @click="goDetail1(item.id)"
                  @error="defaultPro()"
                  :src="item.thumb"
                  :style="reductionH"
                />
                <!-- <img class="reback" src="../../assets/selfSupport/reback.png"/> -->
              </div>
              <p class="name" @click="goDetail1(item.id)">
                <!-- <span class="label_zy">自营</span> -->
                {{ item.name }}
              </p>
              <p class="price">￥{{ item.activity_min_price }}</p>
            </van-col>
          </van-row>
        </div>
      </div>

      <div
        class="electric-active electric-active2"
        v-if="fullpackageShow && fullpackage_data.goods"
      >
        <div class="wrap">
          <van-row class="tit">
            <div @click="fullpackage()">
              <van-col span="12" class="leftT"
                ><span>满额包邮</span
                ><img src="../../assets/selfSupport/shangpinfenzu@2x.png"
              /></van-col>
              <van-col span="12" class="rightT">距结束仅剩</van-col>
              <van-col span="12" class="leftB"
                >满{{
                  fullpackage_data.activity.amount_requirements
                }}元包邮</van-col
              >
              <van-col span="12" class="rightB">
                <van-count-down :time="time3">
                  <template v-slot="timeData">
                    <span>{{ checkTime(timeData.days) }}</span
                    >天<span>{{ checkTime(timeData.hours) }}</span
                    >时<span>{{ checkTime(timeData.minutes) }}</span
                    >分<span>{{ checkTime(timeData.seconds) }}</span
                    >秒
                  </template>
                </van-count-down>
              </van-col>
            </div>
          </van-row>
          <van-row class="product">
            <van-col
              span="8"
              v-for="(item, index) in fullpackage_data.goods"
              :key="index"
              v-if="index < 3"
            >
              <div class="img">
                <img
                  class="imgPro"
                  @click="goDetail1(item.id)"
                  :src="item.thumb"
                  @error="defaultPro()"
                  :style="reductionH"
                />
                <!-- <img class="reback" src="../../assets/selfSupport/reback.png"/> -->
              </div>
              <p class="name" @click="goDetail1(item.id)">
                <!-- <span class="label_zy">自营</span> -->
                {{ item.name }}
              </p>
              <p class="price">￥{{ item.activity_min_price }}</p>
            </van-col>
          </van-row>
        </div>
      </div>

      <van-row class="electric-like" v-if="listL[0]">
        <van-col class="title" span="24">
          <p>
            <img src="../../assets/selfSupport/fenzutitle2.png" /><span>{{
              lovely_big_title
            }}</span
            ><img src="../../assets/selfSupport/fenzutitle1.png" />
          </p>
          <p class="tip">{{ lovely_small_title }}</p>
        </van-col>
      </van-row>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="listL">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="别拉了，小巴也是有底线的"
          @load="onLoad"
        >
          <van-row class="electric-like">
            <van-col span="12">
              <div
                class="goods leftGoods"
                v-for="(item, index) in listL"
                :key="index"
              >
                <div class="img">
                  <img
                    class="imgPro"
                    @click="goDetail1(item.id)"
                    :src="item.thumb"
                    @error="defaultPro()"
                    :style="likestyle"
                  />
                  <!-- <img class="reback" src="../../assets/selfSupport/reback.png"/> -->
                </div>
                <div @click="goDetail1(item.id)">
                  <p class="label">
                    <!-- <span class="label_zy">自营</span> -->
                    <span class="label_zy label_mj" v-show="item.discount == 1"
                      >满减</span
                    ><span
                      class="label_zy label_by"
                      v-show="item.postage_free == 1"
                      >包邮</span
                    >
                  </p>
                  <p class="name">
                    <img :src="item.label" v-if="item.label" />
                    <img :src="item.tag_icon" v-if="item.tag_icon" />
                    {{ item.name }}
                  </p>
                  <p class="price">
                    ￥{{ item.activity_min_price }}
                    <del
                      v-if="item.strikeout_price && item.strikeout_price != 0"
                      >￥{{ item.strikeout_price }}</del
                    ><del v-else>￥{{ item.activity_max_price }}</del>
                  </p>
                </div>
              </div>
            </van-col>
            <van-col span="12">
              <div
                class="goods rightGoods"
                v-for="(item, index) in listR"
                :key="index"
              >
                <div class="img">
                  <img
                    class="imgPro"
                    @click="goDetail1(item.id)"
                    :src="item.thumb"
                    @error="defaultPro()"
                    :style="likestyle"
                  />
                  <!-- <img class="reback" src="../../assets/selfSupport/reback.png"/> -->
                </div>
                <div @click="goDetail1(item.id)">
                  <p class="label">
                    <!-- <span class="label_zy">自营</span> -->
                    <span class="label_zy label_mj" v-show="item.discount == 1"
                      >满减</span
                    ><span
                      class="label_zy label_by"
                      v-show="item.postage_free == 1"
                      >包邮</span
                    >
                  </p>
                  <p class="name">
                    <img :src="item.label" v-if="item.label" />
                    <img :src="item.tag_icon" v-if="item.tag_icon" />
                    {{ item.name }}
                  </p>
                  <p class="price">
                    ￥{{ item.activity_min_price }}
                    <del
                      v-if="item.strikeout_price && item.strikeout_price != 0"
                      >￥{{ item.strikeout_price }}</del
                    ><del v-else>￥{{ item.activity_max_price }}</del>
                  </p>
                </div>
              </div>
            </van-col>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import searchbefore from "@/assets/selfSupport/searchbefore@2x.png";
import searchlast from "@/assets/selfSupport/searchlast_electric@2x.png";

import defaultImg from "@/assets/common/ListPreload.png";
import productDefault from "@/assets/common/preload.png";
import defaultIcon from "@/assets/selfSupport/marketResult1.jpg";

const adMap = {
  1: "shallBuy_supermarket_first_third",
  2: "shallBuy_equipment_first_third",
  5: "shallBuy_clothes_first_third",
  6: "shallBuy_jewelry_first_third",
  8: "shallBuy_typ_first_third",
};

export default {
  data() {
    return {
      value: "", //旺仔小牛奶
      electricFixedTop: false, //吸顶
      searchImgT: searchbefore,
      searchImgB: searchlast,
      current: 0, //吸顶样式切换
      label: 0,
      slideLen: 0, //轮播图length
      isA: false, //控制分类区域class
      isiOSX: false,
      logo: "",
      swiper: [],
      adv: [], //广告位
      shopNotic: "", //店铺公告
      // dayGoods: [],//每日好货
      // miaosha_data: {},//秒杀单品
      top_cate: [], //分类
      miaoshaBegin: "", //秒杀场次
      downcount: {
        //秒杀结束倒计时
        hh: "",
        mm: "",
        ss: "",
      },
      reduction_downcount: {
        //满减结束倒计时
        dd: "",
        hh: "",
        mm: "",
        ss: "",
      },
      fullpackage_downcount: {
        //满额包邮结束倒计时
        dd: "",
        hh: "",
        mm: "",
        ss: "",
      },
      // miaoshaShow: true,//秒杀是否显示
      reductionShow: true, //满额立减是否显示
      reduction_data: {}, //满额立减数据
      fullpackageShow: true, //满额包邮是否显示
      fullpackage_data: {}, //满额包邮数据
      recommendstyle: {
        //秒杀单品样式
        width: (document.body.clientWidth - 68) / 3 + "px",
      },
      recommendstyle_img: {
        width: (document.body.clientWidth - 68) / 3 + "px",
        height: (document.body.clientWidth - 68) / 3 + "px",
      },
      // dayGoodsH:{//每日好货样式
      //   height: (document.body.clientWidth - 48) / 3 + 'px'
      // },
      reductionH: {
        //满额立减和满额包邮样式
        height: (document.body.clientWidth - 32) / 3 - 12 + "px",
      },
      likestyle: {
        height: (document.body.clientWidth - 34) / 2 + "px",
      },
      topCateP: {
        marginLeft: (document.body.clientWidth - 64) / 24 + "px",
      },
      listL: [],
      listR: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 0,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      shopId: 1,
      route_url: "",
      classifyID: 0,
      adv_url: "",
      goodsId: 0,
      lovely_big_title: "",
      lovely_small_title: "",
      time1: 0,
      time2: 0,
      time3: 0,
      order_by: "",
      sort: "desc",
      flags: false,
      //			scrollWidth: {width: '100%'},
      searchBg: "",
      ptAd: false,
    };
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.shopId = this.$route.query.shopid;
    this.isiOSX = this.isIphoneX();
    this.getShopInfo();
    //		this.getNotice();
    this.fullReduction();
    this.fullPackage();
    this.getAdList();
  },
  mounted() {
    document
      .querySelector(".electric-content")
      .addEventListener("scroll", this.handleScroll);
    document.querySelector("#changeSearch").style.backgroundColor =
      "rgba(" + this.searchBg + ", 0)";
  },
  methods: {
    handleScroll() {
      //页面滚动
      var scrollTop = document.querySelector(".electric-content").scrollTop;
      var offsetTop = document.querySelector("#changeSearch").offsetTop;
      var offsetTop = 140;
      var point = Number(scrollTop / 140).toFixed(1);
      if (scrollTop > offsetTop) {
        this.electricFixedTop = true;
        this.current = 1;
        document.querySelector("#changeSearch").style.backgroundColor =
          "rgba(" + this.searchBg + ", 1)";
      } else {
        this.electricFixedTop = false;
        this.current = 0;
        if (point < 0.3) {
          document.querySelector("#changeSearch").style.backgroundColor =
            "rgba(" + this.searchBg + ", 0)";
        } else {
          document.querySelector("#changeSearch").style.backgroundColor =
            "rgba(" + this.searchBg + ", " + point + ")";
        }
      }
    },
    onChange(index) {
      //轮播切换
      this.label = index;
      this.searchBg = this.colorRgb(
        this.swiper[index].background_color
          ? this.swiper[index].background_color
          : ""
      );
      this.handleScroll();
    },
    colorRgb(sColor) {
      sColor = sColor.toLowerCase();
      //十六进制颜色值的正则表达式
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // 如果是16进制颜色
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          var sColorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        //处理六位的颜色值
        var sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
        }
        return sColorChange.join(",");
      }
      return sColor;
    },
    //获取广告
    getAdList() {
      let req = [];
      switch (this.shopId) {
        case "1":
          req = [
            "shallBuy_supermarket_first_top",
            "shallBuy_supermarket_first_middle",
          ];
          break;
        case "2":
          req = [
            "shallBuy_equipment_first_top",
            "shallBuy_equipment_first_middle",
          ];
          break;
        case "5":
          req = ["shallBuy_clothes_first_top", "shallBuy_clothes_first_middle"];
          break;
        case "6":
          req = [
            "shallBuy_jewelry_first_top",
            "shallBuy_jewelry__first_middle",
          ];
          break;
        case "7":
          req = [
            "shallBuy_furniture_first_top",
            "shallBuy_furniture_first_middle",
          ];
          break;
        case "8":
          req = ["shallBuy_typ_first_top", "shallBuy_typ_first_middle"];
          break;
      }
      let _ptTag = adMap[this.shopId];
      this.$api
        .post("/adspace/index/get/ad/list", {
          labels: req.concat([_ptTag]),
        })
        .then((res) => {
          if (res[req[0]] && res[req[0]].length == 0) {
            this.swiper = ["aaa.png"];
          } else {
            this.swiper = res[req[0]];
            this.searchBg = this.colorRgb(
              this.swiper[0].background_color
                ? this.swiper[0].background_color
                : ""
            );
          }
          this.adv = res[req[1]];
          this.slideLen = res[req[0]].length;
          this.ptAd = res[_ptTag] && res[_ptTag][0];
          if (!this.adv[0]) {
            this.advMargin = {
              marginTop: -(document.body.clientWidth * 0.27) + "px",
            };
          }
        });
    },
    getShopInfo() {
      this.$api
        .post("/activity/index/ad/get-self-index", { self_id: this.shopId })
        .then((res) => {
          this.value = res.hot_search_words;
          if (res.self_data) {
            this.logo = res.self_data.logo;
            this.lovely_big_title = res.self_data.lovely_big_title;
            this.lovely_small_title = res.self_data.lovely_small_title;
            var dise = res.self_data.lovely_merchandise_recommendation;
            if (dise == 1) {
              this.order_by = "approve_time";
            } else if (dise == 2) {
              this.order_by = "sales";
            } else if (dise == 3) {
              this.order_by = { approve_time: "desc", sales: "desc" };
            }
          }
          this.flags = true;
          this.like();
          // this.dayGoods = res.ad[2].adData;
          //         if(res.miaosha_data.list[0]) {
          //         	this.miaosha_data = res.miaosha_data;
          // //					this.scrollWidth.width = (document.body.clientWidth * 0.24 + 12) * this.miaosha_data.list.length + 20 + 'px';
          //         	this.miaoshaBegin = this.miaosha_data.orther_config.time_data.begin;
          // 	        var begin_time = this.miaosha_data.orther_config.time_data.begin_time;
          // 	        var end_time = this.miaosha_data.orther_config.time_data.end_time;
          // 	        this.setTimer(1, begin_time, end_time);
          //         }else{
          //         	this.miaoshaShow = false;
          // //      	this.miaosha_data = null;
          //         }

          //过滤掉不需要显示的数据
          for (var i in res.top_cate) {
            if (res.top_cate[i].status == 1) {
              res.top_cate[i].icon = res.top_cate[i].icon || "aaa.png";
              this.top_cate.push(res.top_cate[i]);
            }
          }
          //控制分类项高度
          if (this.top_cate.length > 5) {
            this.isA = true;
          }
        });
    },
    //	getNotice() {//店铺公告  本期不做
    //		this.$api.get("/cms/member/shop/notice/detail", {type: 1, store_id: this.shopId}).then(res => {
    //      this.shopNotic = res.title;
    //    });
    //	},
    fullReduction() {
      //满额立减
      this.$api
        .get("/onshop/index/shop-activity/biggest-discount", {
          self_id: this.shopId,
        })
        .then((res) => {
          if (res.activity.type == undefined || res.goods == null) {
            this.reductionShow = false;
          } else {
            this.reduction_data = res;

            var begin_time = this.date2timestamp(
              this.reduction_data.activity.begin_time
            );
            var end_time = this.date2timestamp(
              this.reduction_data.activity.end_time
            );
            this.setTimer(2, begin_time, end_time);
          }
        });
    },
    fullPackage() {
      //满额包邮
      this.$api
        .get("/onshop/index/postage-activity/lowest-requirement", {
          self_id: this.shopId,
        })
        .then((res) => {
          if (res.activity.type == undefined || res.goods == null) {
            this.fullpackageShow = false;
          } else {
            this.fullpackage_data = res;

            var begin_time = this.date2timestamp(
              this.fullpackage_data.activity.begin_time
            );
            var end_time = this.date2timestamp(
              this.fullpackage_data.activity.end_time
            );
            this.setTimer(3, begin_time, end_time);
          }
        });
    },
    like() {
      //猜你喜欢
      if (this.page == 0 || !this.flags) {
        return;
      }
      this.$api
        .post("/ongoods/index/goods/guess-like", {
          self_id: this.shopId,
          page: this.page,
        })
        .then((res) => {
          if (this.order_by) {
            this.allList = res.total;
            if (res.list.length > 0) {
              // for(let i in res.list) {
              // 	this.list.push(res.list[i]);
              // }
              res.list.forEach((item, i) => {
                if (i % 2 == 0) {
                  this.listL.push(item);
                } else {
                  this.listR.push(item);
                }
              });
            }
            this.loading = false;
            if (this.listL.length + this.listR.length >= this.allList) {
              // 数据全部加载完成
              this.finished = true;
            }
            if (this.isLoading) {
              this.$toast("刷新成功");
              this.isLoading = false;
            }
          }
        });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.like();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.listL = [];
      this.listR = [];
      this.like();
    },
    setTimer(flag, begin_time, end_time) {
      //flag：1秒杀  2满额立减  3满额包邮
      // if(flag == 1){
      // 	var current = Math.floor(new Date().getTime() / 1000);
      // 	var starts = begin_time - current;
      // 	var ts = end_time - current;
      // if (ts <= 0 || starts > 0) {
      // 	//倒计时结束
      // 	this.miaoshaShow = false;
      // }else {
      // 	var current = Math.floor(new Date().getTime());
      // 		this.time1 = Number(end_time+'000') - current;
      // }
      // }else
      if (flag == 2) {
        var current = Math.floor(new Date().getTime() / 1000);
        var starts = begin_time - current;
        var ts = end_time - current;
        if (ts <= 0 || starts > 0) {
          //倒计时结束
          this.reductionShow = false;
        } else {
          var current = Math.floor(new Date().getTime());
          this.time2 = Number(end_time + "000") - current;
        }
      } else {
        var current = Math.floor(new Date().getTime() / 1000);
        var starts = begin_time - current;
        var ts = end_time - current;
        if (ts <= 0 || starts > 0) {
          //倒计时结束
          this.fullpackageShow = false;
        } else {
          var current = Math.floor(new Date().getTime());
          this.time3 = Number(end_time + "000") - current;
        }
      }
    },
    goBack() {
      //返回
      this.params("", "", "goBack");
    },
    support() {
      //分享
      this.params("", "", "support");
    },
    search() {
      //搜索
      this.params(this.value, this.value, "search");
    }, //route_url
    Router(router) {
      //轮播
      if (router) {
        this.invokeStat("List_electric_banner1");
        this.route_url = router;
        this.goRouter();
      }
    },
    goRouter() {
      //轮播
      this.params(this.route_url, this.route_url, "goRouter");
    }, //classifyID
    classify1(id) {
      //分类
      this.classifyID = id;
      this.classify();
    },
    classify() {
      //分类
      this.params(this.classifyID, this.classifyID, "classify");
    },
    notice() {
      //公告
      this.params("", "", "notice");
    },
    dftAdv(router) {
      this.invokeStat("List_electric_banner2");
      //广告位
      this.adv_url = router;
      this.adv_method();
    },
    ptAdv(router) {
      this.invokeStat("List_electric_banner3");
      this.adv_url = router;
      this.adv_method();
    },
    adv_method() {
      //广告位
      this.params(this.adv_url, this.adv_url, "adv_method");
    },
    moreDayrec() {
      //每日好货more
      this.params("", "", "moreDayrec");
    }, //goodsId
    goDetail1(id) {
      //商品详情
      this.goodsId = id;
      this.goDetail();
    },
    goDetail() {
      //商品详情
      this.params(this.goodsId, this.goodsId, "goDetail");
    },
    moreSpike() {
      //每日秒杀more
      this.params("", "", "moreSpike");
    },
    fullpackage() {
      //满额包邮
      this.params("", "", "fullpackage");
    },
    reduction() {
      //满额立减
      this.params("", "", "reduction");
    },
    advDefault() {
      var img = event.srcElement;
      img.src = defaultImg;
      img.onerror = null; //防止闪图
    },
    iconDefu() {
      var img = event.srcElement;
      img.src = defaultIcon;
      img.onerror = null; //防止闪图
    },
    defaultPro() {
      var img = event.srcElement;
      img.src = productDefault;
      img.onerror = null; //防止闪图
    },
  },
  destroyed() {
    document
      .querySelector(".electric-content")
      .removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less">
.electric {
  height: 100%;
  background: #f2f2f2;
  &-search {
    position: fixed;
    top: 0px;
    left: 0;
    z-index: 10;
    padding: 0;
    width: 100%;
    padding-top: 21px;
    /*background: rgba(0,0,0,0) !important;*/
    .back {
      width: 15px;
      padding: 8px;
      position: fixed;
      top: 29px;
      left: 16px;
      z-index: 9;
    }
    .littleTitle {
      /*width: 71px;*/
      height: 25px;
      position: fixed;
      top: 31px;
      left: 42px;
      z-index: 9;
    }
    .search {
      width: 16px;
      position: fixed;
      top: 37px;
      left: 145px;
      z-index: 9;
    }
    .share {
      width: 22px;
      position: fixed;
      top: 43px;
      right: 17px;
      z-index: 9;
    }
    .van-search {
      padding: 6px 16px;
      background: rgba(0, 0, 0, 0) !important;
      .van-field__control {
        color: #fff;
        font-size: 14px;
      }
      input::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: #fff !important;
        font-size: 14px;
      }
      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #fff !important;
        font-size: 14px;
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #fff !important;
        font-size: 14px;
      }
      input:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #fff !important;
        font-size: 14px;
      }
      .van-search__content {
        padding-left: 114px;
        padding-right: 35px;
        background: rgba(0, 0, 0, 0) !important;
      }
      .van-cell {
        padding: 5px 15px 5px 38px;
        border-radius: 17px;
        background: rgba(255, 255, 255, 0.25);
        .van-field__left-icon {
          display: none;
        }
      }
    }
  }
  &-content {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .electric-swipe {
      background: #f2f2f2;
      height: auto !important;
      .item {
        width: 100%;
        height: auto !important;
        min-height: 270px;
      }
      .custom-indicator {
        /*position: relative;*/
        height: 100%;
        color: rgba(0, 0, 0, 0);
        .indexes {
          width: 33px;
          height: 20px;
          line-height: 20px;
          border-radius: 10px;
          color: #fff;
          font-size: 12px;
          text-align: center;
          background: rgba(29, 30, 31, 0.65);
          display: inline-block;
          position: absolute;
          left: 8.5%;
          bottom: 11.5%;
          z-index: 5;
        }
      }
    }
    .electric-model {
      .van-swipe-item {
        min-height: 100px !important;
        height: auto;
        .swipeBox {
          padding: 0 16px;
          background: #f2f2f2;
          height: 100px;
          .box {
            padding: 16px 16px 0;
            background: #fff;
            height: calc(100% - 16px);
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            .van-row--justify-space-between {
              padding-bottom: 14px;
            }
          }
        }
      }
      .class-a {
        height: 184px !important;
        .swipeBox {
          height: 184px;
        }
      }
      img {
        width: 44px;
        height: 44px;
        margin-bottom: 8px;
        vertical-align: bottom;
        display: inline-block;
      }
      .van-col--4 {
        text-align: center;
        font-size: 12px;
      }
      .bottom {
        padding-top: 16px;
      }
      .van-col--4:nth-child(1) {
        margin-left: 0 !important;
      }
      .van-swipe__indicators {
        width: 32px;
        bottom: 6px;
      }
      .van-swipe__indicator {
        width: 20px;
        height: 2px;
        background: rgba(85, 85, 85, 0.2);
      }
      .van-swipe__indicator--active {
        width: 20px;
        height: 2px;
        border-radius: 1px;
        background: #ff4a4a;
      }
      .van-swipe__indicator:not(:last-child) {
        margin-right: 4px;
      }
    }
    .electric-notice {
      padding: 0 16px;
      border-top: solid 1px #f5f6f7;
      background: #f2f2f2;
      position: relative;
      img {
        position: absolute;
        width: 24px;
        top: 10px;
        left: 28px;
        z-index: 8;
      }
      .hot {
        color: #ff5019;
        font-size: 11px !important;
        width: 32px;
        height: 18px;
        line-height: 18px;
        background: rgba(255, 80, 25, 0.1);
        position: absolute;
        top: 8px;
        left: 60px;
        z-index: 8;
        text-align: center;
      }
      .van-notice-bar {
        padding: 0 16px 0 80px;
        height: 34px;
        color: #555;
        font-size: 13px;
        background: #ffffff;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        .van-notice-bar__left-icon {
          margin-right: 8px;
        }
      }
    }
    .electric-adv {
      padding: 0 16px;
      background: #f2f2f2;
      img {
        width: 100%;
        margin-top: 17px;
        display: block;
        min-height: 75px;
      }
    }
    .electric-dayrec {
      background: #fff;
      .title {
        height: 50px;
        padding: 25px 16px 0;
        font-size: 18px;
        color: #333;
        background: -webkit-linear-gradient(
          #f2f2f2,
          #ffffff
        ); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(
          #f2f2f2,
          #ffffff
        ); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(
          #f2f2f2,
          #ffffff
        ); /* Firefox 3.6 - 15 */
        background: linear-gradient(
          #f2f2f2,
          #ffffff
        ); /* 标准的语法（必须放在最后） */
      }
      .label {
        padding-left: 16px;
        margin-top: 5px;
        span {
          color: #fff;
          font-size: 12px;
          width: 92px;
          height: 20px;
          line-height: 20px;
          border-radius: 3px;
          display: inline-block;
          text-align: center;
          background: -webkit-linear-gradient(
            to right,
            #35d4e6,
            #35e6a8
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            to right,
            #35d4e6,
            #35e6a8
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            to right,
            #35d4e6,
            #35e6a8
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #35d4e6, #35e6a8);
          img {
            width: 7px;
          }
        }
      }
      .more {
        font-size: 14px;
        color: #34d8d5;
        text-align: right;
        padding-right: 16px;
        height: 20px;
        line-height: 20px;
        margin-top: 5px;
        img {
          width: 9px;
          float: right;
          margin-top: 5px;
        }
      }
    }
    .electric-dayrec-list {
      padding: 12px 12px 16px;
      background: #fff;
      .van-col {
        padding: 4px;
        img {
          border-radius: 3px;
          background: #d8d8d8;
          width: 100%;
          display: block;
        }
      }
    }
    .electric-spike {
      .title {
        color: #333;
        font-size: 18px;
        padding: 0 16px;
        height: 25px;
        line-height: 25px;
      }
      .label {
        padding-left: 16px;
        margin-top: 5px;
        color: #1d1e1f;
        .time {
          color: #fff;
          font-size: 12px;
          width: auto;
          padding: 0 5px;
          height: 20px;
          line-height: 20px;
          border-radius: 3px;
          display: inline-block;
          text-align: center;
          margin-right: 8px;
          background: -webkit-linear-gradient(
            to right,
            #ff4444,
            #ff8888
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            to right,
            #ff4444,
            #ff8888
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            to right,
            #ff4444,
            #ff8888
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #ff4444, #ff8888);
        }
        .van-count-down {
          display: inline !important;
          .downcount {
            color: #fff;
            font-size: 12px;
            width: 18px;
            height: 17px;
            line-height: 17px;
            background: #1d1e1f;
            border-radius: 2px;
            display: inline-block;
            text-align: center;
          }
        }
      }
      .more {
        font-size: 14px;
        color: #ff4a4a;
        text-align: right;
        padding-right: 16px;
        height: 20px;
        line-height: 20px;
        margin-top: 5px;
        img {
          width: 9px;
          float: right;
          margin-top: 5px;
        }
      }
      .wrapper {
        width: 100%;
        background: #fff;
        .datePrice {
          width: 100%;
          overflow-x: scroll;
          padding-top: 12px;
          .clearfix {
            overflow: hidden;
            white-space: nowrap;
            width: 100%;
            padding: 0 4px;
            li {
              float: left;
              margin-right: 12px;
              background: #ffffff;
              position: relative;
              overflow: hidden;
              .imgCon {
                width: 100%;
                background: #ffffff;
                border-radius: 3px;
                position: relative;
                .imgPro {
                  width: 100%;
                  height: 100%;
                  border-radius: 3px;
                  display: block;
                }
                .reback {
                  width: 14px;
                  display: inline-block;
                  position: absolute;
                  right: 0;
                  bottom: 0;
                }
              }
              .name {
                font-size: 12px;
                color: #333;
                margin: 4px 0 2px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                height: 20px;
                line-height: 20px;
              }
              .price {
                font-size: 13px;
                color: #f24724;
                margin: 0;
                height: 21px;
                line-height: 21px;
                margin-bottom: 24px;
                del {
                  font-size: 10px;
                  color: #bbb;
                  margin-left: 3px;
                }
              }
            }
            li:nth-child(1) {
              margin-left: 12px;
            }
            /*li.empty {
							width: 4px;
							margin-right: 0px;
							color: rgba(0, 0, 0, 0);
							background: rgba(0, 0, 0, 0);
						}*/
          }
        }
      }
    }
    .electric-active {
      padding: 0 12px 26px;
      background: #fff;
      .wrap {
        height: auto;
        background: url(../../assets/selfSupport/fenzubg2.png) no-repeat center
          center;
        background-size: 100% 100%;
        .tit {
          padding: 16px;
          color: #fff;
          .van-col {
            height: 25px;
            line-height: 25px;
          }
          .leftB,
          .rightB {
            height: 20px;
            line-height: 20px;
          }
          .leftT {
            font-size: 18px;
            span {
              line-height: 17px;
              float: left;
              padding-top: 2px;
            }
            img {
              width: 18px;
              margin-left: 6px;
            }
          }
          .leftB,
          .rightT {
            font-size: 12px;
          }
          .rightT,
          .rightB {
            text-align: right;
          }
          .rightB {
            font-size: 10px !important;
            .van-count-down {
              color: #fff;
            }
            span {
              color: #4f80f3;
              font-size: 12px;
              height: 17px;
              line-height: 17px;
              text-align: center;
              background: #fff;
              border-radius: 2px;
              display: inline-block;
              margin: 0 2px;
              min-width: 15px;
              padding: 0 2px;
            }
          }
        }
        .product {
          padding: 0 4px;
          .van-col {
            padding: 0 4px;
            .img {
              padding: 2px;
              border-radius: 2px;
              background: #fff;
              position: relative;
              .imgPro {
                width: 100%;
                border-radius: 1px;
                display: block;
              }
              .reback {
                width: 14px;
                display: inline-block;
                position: absolute;
                right: 0;
                bottom: 0;
              }
            }
            .name {
              font-size: 12px;
              color: #333;
              padding-left: 4px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              height: 20px;
              line-height: 20px;
              margin: 0;
            }
            .price {
              padding-left: 4px;
              font-size: 15px;
              color: #f24724;
              margin: 0;
              height: 21px;
              line-height: 21px;
            }
          }
        }
      }
    }
    .electric-active2 {
      padding: 0 16px 24px;
      .wrap {
        height: auto;
        background: url(../../assets/selfSupport/fenzubg1.png) no-repeat center
          center;
        background-size: 100% 100%;
        .tit {
          .rightB {
            span {
              color: #ff4a4a;
            }
          }
        }
        .product {
          padding: 0;
          .van-col {
            .name,
            .price {
              padding-left: 0;
            }
          }
        }
      }
    }
    .electric-like {
      width: 100%;
      background: #fff;
      .title {
        p {
          margin: 0;
          text-align: center;
          height: 21px;
          line-height: 21px;
          color: #ff9259;
          font-size: 15px;
          img {
            width: 26px;
            margin: 0 4px;
            vertical-align: middle;
          }
        }
        .tip {
          color: #999;
          font-size: 12px;
          height: 17px;
          line-height: 17px;
          margin: 2px 0 12px;
        }
      }
      .van-col--12 {
        .goods {
          .img {
            position: relative;
            .imgPro {
              width: 100%;
              display: block;
              border-radius: 5px;
            }
            .reback {
              width: 14px;
              display: inline-block;
              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
          .label {
            margin-top: 9px;
          }
          .name {
            color: #333;
            font-size: 14px;
            height: 42px;
            line-height: 21px;
            overflow: hidden;
            margin-top: 6px;
            // text-overflow: ellipsis;
            display: -webkit-box;
            // -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            img {
              vertical-align: middle;
              margin-right: 10px;
              height: 20px;
            }
          }
          .price {
            height: 25px;
            line-height: 25px;
            color: #ff3b30;
            font-size: 18px;
            margin: 4px 0 8px;
            del {
              color: #bbbbbb;
              font-size: 12px;
            }
          }
        }
        .leftGoods {
          padding: 0 4px 0 16px;
        }
        .rightGoods {
          padding: 0 16px 0 4px;
        }
      }
    }
    .electric-end {
      height: 50px;
      line-height: 50px;
      background: #f5f6f7;
      text-align: center;
      .end-word {
        position: relative;
        color: #ccc;
        font-size: 13px;
        background: #f5f6f7;
        span {
          width: 40px;
          height: 1px;
          background: #ddd;
          position: absolute;
          top: 6px;
        }
        .left {
          left: -48px;
        }
        .right {
          right: -48px;
        }
      }
    }
  }
  .label_zy {
    width: 34px;
    height: 13px;
    line-height: 13px;
    border-radius: 2px;
    background: #e95a27;
    border: solid 1px #e95a27;
    color: #ffffff;
    font-size: 11px;
    margin-right: 6px;
    text-align: center;
    padding: 0;
    display: inline-block;
  }
  .label_mj {
    color: #ef5454;
    border: solid 1px #ef5454;
    background: #ffffff;
  }
  .label_by {
    color: #f5a359;
    border: solid 1px #f5a359;
    background: #ffffff;
  }
}

.electricFixedTop {
  .littleTitle {
    display: none;
  }
  .search {
    left: 58px;
  }
  .van-search__content {
    padding-left: 26px !important;
  }
  .van-cell {
    background: #f2f2f2 !important;
    /*.van-field__control {
			color: #CDAD8A;
		}
		input::-webkit-input-placeholder {
		  color: #CDAD8A !important;
		}
		input:-moz-placeholder {
		  color: #CDAD8A !important;
		}
		input::-moz-placeholder {
			color: #CDAD8A !important;
		}
		input:-ms-input-placeholder {
		  color: #CDAD8A !important;
		}*/
  }
}

.isiOSX {
  padding-top: 41px;
  .back {
    top: 49px;
  }
  .search {
    top: 58px;
  }
  .share {
    top: 63px;
  }
  .littleTitle {
    top: 51px;
  }
}

// 拼团活动
.groupbuy {
  margin: 20px 16px;
  width: calc(100% - 32px);
  height: 148px;
  border-radius: 3px;
  overflow: hidden;
}
</style>
